import { useOuterApiPanel } from './useOuterApiPanel';
import Icon from '../../Layout/Icon';
import * as React from 'react';
import { CONNECTED_API_TYPE } from '../../../Model/Enums';

export const OuterApiPanel = () => {
  const { handleAggreg8, handleSzamlazzhu, closeDialog } = useOuterApiPanel();

  return (
    <div>
      <div className="row">
        <div className="col-6 p-5 text-center">
          <button
            onClick={handleSzamlazzhu}
            className="btn btn-lg "
            style={{ backgroundColor: '#FF6630' }}
            data-testid="szamlazzhuBtn"
          >
            <Icon
              src={'/img/logo.svg'}
              originate={CONNECTED_API_TYPE.SZAMLAZZHU}
              style={{ width: '125px', objectFit: 'contain' }}
            />
          </button>
        </div>
        <div onClick={() => handleAggreg8(false, null)} className="col-6 p-5 text-center">
          <button className="btn btn-lg " data-testid="aggreg8Btn">
            <Icon
              src={'/img/aggre8_logo.png'}
              originate={CONNECTED_API_TYPE.AGGREG8}
              style={{ width: '125px', objectFit: 'contain' }}
            />
          </button>
        </div>
      </div>
      <div className=" row ">
        <div className=" col-12 d-flex align-items-center justify-content-end">
          <button onClick={closeDialog} className="btn btn-secondary" data-testid="closeApiIndexBtn">
            Bezár
          </button>
        </div>
      </div>
    </div>
  );
};
